import { api } from '../service/api.service'

export default class MagicLinkStore {
  async magicLinkVerification(value) {
    const res = await api.post('/magic-link/verification', {
      value
    })
    return res.data
  }
}